<template>
	<div class="page-container">
		<head-top head-title="消息详情" goBack="true"></head-top>

		<div class="detail-page">
			<div class="detail-card bg_a">
				<div class="detail-title">{{ message.noticeTitle }}</div>
				<div class="detail-time">{{ message.createTime}}</div>
				<div class="detail-content" v-html="message.noticeContent"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import { getNoticeDetail } from '@/apis/api.js'

	export default {
		name: 'MessageDetail',
		components: {
			headTop: headTop
		},
		data() {
			return {
				message: {
					title: '',
					content: '',
					createTime: ''
				}
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				const id = this.$route.query.id
				if (!id) {
					this.$toast('消息ID不存在')
					return
				}
				this.$toast.loading({ message: '加载中...', duration: 0 })
				getNoticeDetail(id)
					.then(res => {
						this.$toast.clear()
						this.message = res || {
							title: '消息不存在',
							content: '<p>该消息已被删除或不存在</p>',
							createTime: '-'
						}
					})
					.catch(e => {
						this.$toast.clear()
						if (e.handled) return
						this.$toast(e.msg || '加载失败')
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.page-container {
		padding-top: 48px;

		.detail-page {
			padding: 14px;

			.detail-card {
				padding: 16px;
				border-radius: 8px;

				.detail-title {
					word-break: break-all;
					font-size: 16px;
					font-weight: bold;
					color: #333;
					line-height:1.5;
					margin-bottom: 10px;
				}

				.detail-time {
					font-size: 12px;
					color: #999;
					margin-bottom: 16px;
					padding-bottom: 12px;
					border-bottom: 1px solid #f0f0f0;
				}

				.detail-content {
					font-size: 14px;
					color: #666;
					line-height: 1.8;
					word-break: break-all;

					:deep(p) {
						margin-bottom: 10px;
					}

					:deep(ul), :deep(ol) {
						padding-left: 20px;
						margin: 10px 0;
					}

					:deep(li) {
						margin: 5px 0;
					}
				}
			}
		}
	}
</style>